export default "__VITE_ASSET__CU9va8l1__"